export default __webpack_public_path__ + "static/media/icono_saturno_blue.9bb6b61d.svg";